import React, { useState } from 'react';
import { ImageIcon } from 'lucide-react';

/**
 * Screenshot with a caption. `src` is deliberately optional: with no src it
 * renders a labelled dashed placeholder at the right aspect ratio, so every
 * page can be written before any screenshot exists and each missing shot is
 * visible and self-describing rather than a blank gap.
 */
const Shot = ({ src, device = 'desktop', alt = '', caption }) => {
  const [failed, setFailed] = useState(false);
  const aspect = device === 'mobile' ? 'aspect-[9/19] max-w-[260px]' : 'aspect-[16/9] w-full';
  const show = src && !failed;

  return (
    <figure className="not-prose my-6">
      {show ? (
        <img
          src={src}
          alt={alt}
          onError={() => setFailed(true)}
          className={`${aspect} object-cover rounded-xl border border-gray-200 shadow-sm bg-white`}
        />
      ) : (
        <div className={`${aspect} rounded-xl border-2 border-dashed border-gray-300 bg-gray-50 flex flex-col items-center justify-center text-gray-400 gap-2`}>
          <ImageIcon className="w-6 h-6" />
          <p className="text-xs font-medium px-4 text-center">{alt || 'Screenshot pending'}</p>
          <p className="text-[10px] uppercase tracking-wider">{device}</p>
        </div>
      )}
      {caption && <figcaption className="mt-2 text-xs text-gray-500">{caption}</figcaption>}
    </figure>
  );
};

export default Shot;
